export const checkClassficationName = (row, serializedName = 'classification') => {
  const fieldValue = row[serializedName];
  if (!fieldValue) {
    return false;
  }
  if (serializedName !== 'classification') {
    return false;
  }
  return !fieldValue.startsWith('OBS');
};

export const checkRepeatedPrimaryKey = (row, obsParams, serializedName = 'classification') => {
  const fieldValue = row[serializedName];
  if (serializedName === 'classification') {
    if (obsParams.length !== 0) {
      const classificationList = obsParams.map((values) => {
        return values.classification;
      });
      return classificationList.filter((pnc) => {
        return pnc === fieldValue;
      }).length > 1;
    }
  }
  return false;
};

export const checkFieldPattern = (element, serializedName, constraintChecker) => {
  const {includedStr, patternOfComparison} = constraintChecker;
  const fieldValue = element[serializedName];
  const checkedField = serializedName.includes(includedStr);

  if (!checkedField || !fieldValue) {
    return false;
  }

  const result = patternOfComparison.exec(fieldValue);
  if (!result) {
    return true;
  }
  return Number(fieldValue) === 0;
};

export const checkValidRowRange = (row, serializedName = 'daysUntil') => {
  if (serializedName !== 'daysUntil') {
    return false;
  }
  return Number(row[serializedName]) <= Number(row.daysFrom);
};
